import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { weddingPackages } from '../../mocks/wedding-packages';

export default function WeddingPackagesPage() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <div className="relative h-[60vh] min-h-[500px] flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(https://public.readdy.ai/ai/img_res/3d6b5bd1c6d1ec4fc6a433dcf5156c80.jpg)`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 text-left w-full">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6">
            Paquetes de Boda
          </h1>
          <p className="text-xl lg:text-2xl text-gray-200 max-w-2xl mb-8">
            Haz de tu día especial una experiencia inolvidable con nuestros exclusivos paquetes de lujo
          </p>
          <a
            href="https://wa.me/522291578562?text=Hola!%20Me%20interesa%20uno%20de%20sus%20paquetes%20de%20boda%20con%20veh%C3%ADculo%20de%20lujo.%20%C2%BFPueden%20enviarme%20informaci%C3%B3n%20sobre%20disponibilidad%20y%20lo%20que%20incluye%20cada%20paquete%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 text-black px-8 py-4 rounded-full font-bold text-lg hover:from-amber-600 hover:to-amber-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Consultar Disponibilidad
          </a>
        </div>
      </div>

      {/* Packages Section */}
      <div className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Paquetes Exclusivos
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Celebra tu boda con el lujo y la elegancia que mereces. Nuestros paquetes incluyen los vehículos más exclusivos del mundo.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {weddingPackages.map((pkg) => (
              <div
                key={pkg.id}
                className="bg-gray-900 rounded-2xl overflow-hidden border border-amber-900/30 hover:border-amber-500/50 transition-all group"
              >
                <div className="p-8">
                  <div className="text-center mb-6">
                    <h3 className="text-3xl font-bold text-amber-400 mb-2">
                      {pkg.vehicle}
                    </h3>
                    <div className="inline-block bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full text-sm font-semibold">
                      Wedding Package
                    </div>
                  </div>

                  <div className="space-y-6">
                    {/* Duration */}
                    <div className="flex items-center justify-between py-4 border-b border-amber-900/30">
                      <span className="text-gray-400 font-medium">Duración</span>
                      <span className="text-white font-bold text-lg">{pkg.duration}</span>
                    </div>

                    {/* Price */}
                    <div className="flex items-center justify-between py-4 border-b border-amber-900/30">
                      <span className="text-gray-400 font-medium">Costo</span>
                      <span className="text-amber-400 font-bold text-3xl">${pkg.price.toLocaleString()}</span>
                    </div>

                    {/* Includes */}
                    <div className="py-4">
                      <h4 className="text-gray-400 font-medium mb-3">Que incluye</h4>
                      <div className="bg-black/50 rounded-lg p-4 border border-amber-900/20">
                        <p className="text-white leading-relaxed">{pkg.includes}</p>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-gray-300 leading-relaxed">
                      {pkg.description}
                    </p>

                    {/* CTA Buttons */}
                    <div className="space-y-3 pt-4">
                      <a
                        href={`https://wa.me/522291578562?text=${encodeURIComponent(`Hola! Estoy interesado en el paquete de boda con ${pkg.vehicle} a $${pkg.price}. ¿Tienen disponibilidad? Me gustaría conocer todos los detalles del servicio incluido.`)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-black py-4 rounded-full font-bold text-lg hover:from-amber-600 hover:to-amber-700 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line text-2xl"></i>
                        Reservar por WhatsApp
                      </a>
                      <Link
                        to="/contacto"
                        className="w-full bg-gray-800 text-white py-4 rounded-full font-bold text-lg hover:bg-gray-700 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer border border-amber-900/30"
                      >
                        <i className="ri-mail-line text-xl"></i>
                        Contactar por Email
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-16 bg-gradient-to-r from-amber-900/20 to-amber-800/20 rounded-2xl p-8 border border-amber-900/30 max-w-5xl mx-auto">
            <div className="text-center">
              <i className="ri-information-line text-amber-400 text-4xl mb-4"></i>
              <h3 className="text-2xl font-bold text-white mb-4">Información Adicional</h3>
              <div className="text-gray-300 space-y-3 max-w-3xl mx-auto">
                <p>✓ Traslado de cortesía dentro de la zona hotelera de Cancún</p>
                <p>✓ Vehículo decorado especialmente para tu boda</p>
                <p>✓ Conductor profesional incluido</p>
                <p>✓ Sesión fotográfica con el vehículo</p>
                <p>✓ Seguro de cobertura completa</p>
                <p className="text-amber-400 font-semibold pt-4">
                  Reserva con anticipación para garantizar disponibilidad en tu fecha especial
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
